import React, { useEffect } from 'react';
import { View } from 'react-native';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as menuActions } from '../../store/ducks/menu-ativo';
import { Creators as configActions } from '../../store/ducks/config-section';
import RootView from '../rootView';
import styles from './styles';
import OptionsList from './optionsList';
import { Fretes } from './Fretes';
import ConfigurarPedidos from './ConfigurarPedidos';
import { HorarioFuncionamento } from './HorarioFuncionamento';
import { Usuarios } from './Usuarios';
import { FaixasCeps } from './FaixaCep';
import {
    SECTIONS,
    TIPO_ENTREGA_RETIRADA
} from '../../constants/configuracao-horarios';

const Configuracoes = ({ navigation, selectMenu, section, selectSection, selectTab }) => {
    const renderSection = () => {
        switch (section.selectedSection) {
            case SECTIONS.CONFIGURAR_PEDIDOS:
                return <ConfigurarPedidos />;
            case SECTIONS.HORARIO_FUNCIONAMENTO:
                return <HorarioFuncionamento />;
            case SECTIONS.FRETES:
                return <Fretes />;
            case SECTIONS.USUARIOS:
                return <Usuarios />;
            case SECTIONS.FAIXA_CEP:
                return <FaixasCeps />
            default:
                return null;
        }
    };

    useEffect(() => {
        selectMenu('settings-solid');
        selectSection({ selectedSection: SECTIONS.CONFIGURAR_PEDIDOS });
        selectTab({
            idTipoEntregaRetirada: TIPO_ENTREGA_RETIRADA.RETIRADA
        });
    }, []);

    return (
        <RootView navigation={navigation}>
            <View style={styles.container}>
                <View style={styles.content}>
                    <View style={styles.list}>
                        <View style={styles.containerOptions}>
                            <OptionsList useSection={[section]} />
                        </View>
                    </View>
                    {renderSection()}
                </View>
            </View>
        </RootView>
    );
}

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {...menuActions, ...configActions},
        dispatch
    );

const mapStateToProps = ({ section }) => ({
    section
});

export default connect(mapStateToProps, mapDispatchToProps)(Configuracoes);
